module.exports = __webpack_public_path__ + "static/media/individual.6c3c8719.svg";